export const VideoPrefix = {
  small: 'small-video',
  big: 'big-video',
  audio: 'pure-audio',
};

/**
 * @description 浏览器不允许播放的错误code
 * @doc https://trtc-1252463788.file.myqcloud.com/web/docs/tutorial-11-advanced-auto-play-policy.html
 * */
export const PLAY_NOT_ALLOWED = '16451';

/** @description 屏幕共享流的streamType */
export const SCREEN_STREAM_TYPE = 'auxiliary';

export enum RtcMediaPermissionType {
  Camera = 'camera',
  Microphone = 'microphone',
}

export enum RtcMediaPermissionStatus {
  /** @description 允许 */
  Granted = 'granted',
  /** @description 拒绝 */
  Denied = 'denied',
  /** @description 提醒 */
  Prompt = 'prompt',
}
